import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import { categories } from "@/mocks/categories";

const CategoryGrid = () => (
  <section className="bg-background-100">
    <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
      <SectionTitle
        eyebrow="分类归档"
        title="四个抽屉，按主题存放旧料"
        desc="不清楚该从哪看起？先挑一个主题，里面是按年份排好的条目。"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((cat, index) => (
          <Link
            key={cat.id}
            to={`/archive?cat=${cat.id}`}
            className="group flex flex-col rounded-lg border border-foreground-950/10 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="font-heading text-2xl font-black text-background-300">
                {String(index + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
            <div className="mt-5 flex items-center justify-between border-t border-foreground-950/10 pt-4 font-label text-xs text-foreground-500">
              <span>{cat.count} 条已归档</span>
              <span className="flex items-center gap-1 text-primary-600">
                进入
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CategoryGrid;